export default {
    methods: {
        imagePath(path) {
            if (path?.includes('http') || path?.includes('https')) {
                return path;
            }
            return `${this.$config.apiBaseUrl}/${path}`;
        }
    }
};
